import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { Cart } from '~/graphql/graphql';

type CartState = {
  carts: Cart[];
  cartTotalQuantity: number;
  selectedLocationId: string;
};

const initialState: CartState = {
  carts: [],
  cartTotalQuantity: 0,
  selectedLocationId: '',
};

const cartSlice = createSlice({
  name: 'carts',
  initialState,
  reducers: {
    setCarts(state, action: PayloadAction<Cart[]>) {
      state.carts = action.payload;
    },
    setCartTotalQuantity(state, action: PayloadAction<number>) {
      state.cartTotalQuantity = action.payload;
    },
    setSelectedLocationId(state, action: PayloadAction<string>) {
      state.selectedLocationId = action.payload;
    },
  },
});

export const { setCarts, setCartTotalQuantity, setSelectedLocationId } =
  cartSlice.actions;

export default cartSlice.reducer;
